import React from 'react';
import { Empty } from 'antd';
import { AntTable } from './antTable-style';
import EmptyLogo from 'assets/images/Logo_NoData.png';

const TableComponent = ({ className, rowSelection, rowKey, loading, data, columns, onChange }) => {
  const boldColumns = columns.map((column) => ({
    ...column,
    title: <span style={{ fontWeight: 'bold', fontSize: '16px' }}>{column.title}</span>,
  }));

  const customNoDataIcon = (
    <div className='af-table-empty-icon-wrap' style={{ fontWeight: 'bold' }}>
      <Empty className='af-table-empty-icon' image={EmptyLogo} style={{ paddingTop: '80px' }} />
    </div>
  );

  return (
    <AntTable
      className={`${className} af-table-box`}
      loading={loading}
      dataSource={data}
      rowSelection={rowSelection}
      columns={boldColumns}
      onChange={onChange}
      rowKey={rowKey}
      scroll={{
        x: 1000,
      }}
      style={{ borderRadius: '8px' }}
      pagination={false}
      locale={{ emptyText: customNoDataIcon }}
    />
  );
};

export default TableComponent;
